/**
 * PURPOSE: Definir el contrato local de BroadcastChannel para el scoreboard HDMI de Handball.
 * RESPONSIBILITIES:
 *  - Sí: centralizar nombre del canal y tipos de mensaje permitidos.
 *  - Sí: evitar strings sueltos entre planilla y pantalla externa.
 *  - No: no abre canales ni transforma payloads.
 * COLLABORATORS:
 *  - hooks/useHandballScoreboardPublisher.js
 *  - hooks/useHandballScoreboardReceiver.js
 *  - components/scoreboard/HandballScoreboardView.jsx
 * NOTES: BroadcastChannel funciona entre pestañas/ventanas del mismo navegador y mismo origen.
 * ROUTE: src/components/FullScreenModal/FullScreenPlanilla/Handball/constants/handballScoreboardChannel.js
 */

export const HANDBALL_SCOREBOARD_CHANNEL = "winscore_handball_scoreboard_channel";

export const HANDBALL_SCOREBOARD_MESSAGE = Object.freeze({
  REQUEST_CURRENT_STATE: "REQUEST_CURRENT_STATE",
  SYNC_MATCH: "SYNC_MATCH",
  STATE_UPDATE: "STATE_UPDATE",
  REQUEST_FULLSCREEN: "REQUEST_FULLSCREEN",
  SET_ZOOM: "SET_ZOOM",
  ZOOM_IN: "ZOOM_IN",
  ZOOM_OUT: "ZOOM_OUT",
  RESET_ZOOM: "RESET_ZOOM",
  PLANILLA_CLOSED: "PLANILLA_CLOSED",
});
